import BlogPostsProvider from "~providers/blog-posts";
import EventsProvider from "~providers/events";
import Calendar from "~components/calendar/calendar";
import * as React from 'react';
export default {
  BlogPostsProvider,
  EventsProvider,
  Calendar,
  React
};